import axios from 'axios'

const initial = {
  countries() {
    return []
  },
}

const state = {
  countries: initial.countries(),
}

const mutations = {
  SET(state, countries) {
    state.countries = countries
  },
  ERROR(state) {
    state.countries = []
  },
}

const actions = {
  getCountries({ commit }) {
    return new Promise((resolve, reject) => {
      axios('countries')
        .then((response) => {
          const countries = response.data
          commit('SET', countries)
          resolve(response)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  }
}

const getters = {
  countries: state => state.countries,
  countryByID: state => index => state.countries.filter(country => country.id === +index)[0] || {},
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
